import InfoIcon from '../../../../ui/svg/common/info';
import React from 'react';
import {useAppSelector} from '../../DAL/store';
import {rootActions, useAppDispatch} from '../../../account/change-sbs-billing-info/data/store';
import {sendGAEvent} from '../../../../domain/marketing/gtm-provider';
import { SubscriptionPlanModel} from "../../interfaces";

interface ITwoMonthFreeProps {
    PlanAnnual:  SubscriptionPlanModel,
    PlanMonthly:  SubscriptionPlanModel,
    styleType: string
}
const TwoMonthFreePriceDifferent = (props: ITwoMonthFreeProps) => {
    const dispatch = useAppDispatch();
    const IsAnnual = useAppSelector((store) => store.IsAnnual);

    //const PlanSave = Number(((props.PlanMonthly.skU_MSRP * 12) - props.PlanAnnual.skU_MSRP).toFixed(2));
    //console.log('TwoMonthFreePriceDifferent: ',props);

    /*const openPopup = () => {
        dispatch(
            rootActions.main({
                IsTwoMonthFreePopupShown: true,
                PlanSavePopupShown: PlanSave,
                PlanCostPopupShown: props.PlanAnnual.skU_MSRP
            })
        );

        sendGAEvent('Click','You’re save 2 months free');
    };*/

    const goToAnnual = () => {
        dispatch(
            rootActions.main({
                IsAnnual: true,
            })
        );

        sendGAEvent('Click','Pay annually & save 2 months');
    };

    return (
        <div className={`w-full flex items-center mt-5 lg:mt-4 ${props?.styleType === 'center' ? "justify-center" : "justify-start px-8 lg:pl-16" }`}>
            {
                !IsAnnual  &&
                <div className="pr-2"><InfoIcon width="22px" color={"white"} /></div>
            }

            {
                IsAnnual &&
                <></>
            }

            {
                !IsAnnual  &&
                <div className="text-center text-base lg:text-xl">
                    <button
                        type="button"
                        onClick={goToAnnual}
                        className="underline cursor-pointer">
                        Pay annually
                    </button>
                    <span> &amp; </span>
                    <span className="text-yellow-400">save</span>
                </div>
            }
        </div>
    )
};

export default TwoMonthFreePriceDifferent;